<mat-card-content>
  <ng-container *ngIf="domain">
    <table class="mat-table data-table">
      <tr>
        <th>Id</th>
        <td>{{domain.id}}</td>
      </tr>
    </table>

  </ng-container>
  <ng-container *ngIf="domainFormGroup && domain">
    <form class="user-form" [formGroup]="domainFormGroup">
      <mat-grid-list cols="6" rowHeight="100px">

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Zugang</mat-label>
            <mat-select [(value)]="domain.claimName" formControlName="claim_name">
                <mat-option *ngFor="let c of app.claims" value="{{c.name}}">{{c.desc}}</mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Domäne</mat-label>
            <input type="text"
                   value="{{domain.domains.join(', ')}}"
                   matInput
                   formControlName="domains"
                   placeholder="z.B staatsanzeiger.de"
                   matTooltip="Mehrere Einträge müssen durch Komma getrennt werden">
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Gültig von</mat-label>
            <input matInput [matDatepicker]="fromPicker" formControlName="start">
            <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Gültig bis</mat-label>
            <input matInput [matDatepicker]="toPicker" formControlName="expiry">
            <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Laufzeit</mat-label>
            <input type="number" value="{{domain.term}}" matInput formControlName="term">
          </mat-form-field>
        </mat-grid-tile>


        <mat-grid-tile colspan="1">
          <mat-slide-toggle
            formControlName="renewal"
            [checked]="domain.renewal === '1'">
            Auto-Erneuerung
          </mat-slide-toggle>
        </mat-grid-tile>

      </mat-grid-list>


      <div class="actions">
        <button (click)="submitDomain()" mat-raised-button color="accent">Speichern
          <mat-icon>save</mat-icon>
        </button>

        <button (click)="deleteDomainAlert()" mat-raised-button color="warn">Löschen
          <mat-icon>delete</mat-icon>
        </button>
      </div>

    </form>
  </ng-container>

</mat-card-content>



